/** Configuration lue au build (variables VITE_*, voir .env.example). */
import { buildIceConfig } from './net/iceConfig';
import { fetchTurnServers } from './net/turn';
import type { BrokerEnv } from './net/peer';

const env = import.meta.env as Record<string, string | undefined>;

export const iceConfig = buildIceConfig(env);
export const brokerEnv: BrokerEnv = env;

for (const w of iceConfig.warnings) console.warn(w);

/** Relais TURN Cloudflare (Pages Function `/api/ice`) ; absent en local et en e2e → STUN seul. */
export const turnServers = (): Promise<RTCIceServer[]> =>
  fetchTurnServers({
    fetchFn: (url, init) => fetch(url, init),
    url: `${import.meta.env.BASE_URL}api/ice`,
    timeoutMs: 2500,
  });
